var _path, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentageInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1969",
    d: "M54.5 0h-38a16.5 16.5 0 000 33h38a16.5 16.5 0 000-33z",
    fill: "#e5e5e5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1591",
    transform: "translate(3 2)",
    fill: "#fff",
    stroke: "#e5e5e5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 29,
    rx: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 28,
    rx: 14,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "%",
    transform: "translate(28 22)",
    fill: "#95989a",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.204,
    y: 0
  }, "%"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    "data-name": "#",
    transform: "translate(54 22)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.398,
    y: 0
  }, "#"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageInactive);
export default __webpack_public_path__ + "static/media/percentage-inactive.78d77f00ff91173720820f9bfd6d5b69.svg";
export { ForwardRef as ReactComponent };